import { createImageUrlBuilder, SanityImageSource } from "@sanity/image-url";
import { client } from "../client";

const imageBuilder = createImageUrlBuilder(client);
export const imageUrlFor = (source: SanityImageSource) =>
  imageBuilder.image(source);
